import { createFeatureSelector, createSelector } from '@ngrx/store';
import { B2B_UNIT_FEATURE, B2bUnitState } from '@b2b/features/b2b-unit/core/store/b2b-unit.states';

export const selectCurrentB2bUnit = createSelector(
  createFeatureSelector<B2bUnitState>(B2B_UNIT_FEATURE),
  state => state.currentB2bUnit,
);

export const selectPaymentMethods = createSelector(
  createFeatureSelector<B2bUnitState>(B2B_UNIT_FEATURE),
  state => state.paymentMethods,
);

export const selectDefaultPaymentMethod = createSelector(
  createFeatureSelector<B2bUnitState>(B2B_UNIT_FEATURE),
  state => state.defaultPaymentMethod,
);
